import '@polymer/polymer/polymer-legacy.js';
import { KatapultGeometry } from 'katapult-toolbox';
import { GeofireTools } from '../../modules/GeofireTools.js';
import { SquashNulls } from '../../modules/SquashNulls.js';
import { Polymer } from '@polymer/polymer/lib/legacy/polymer-fn.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
Polymer({
  _template: html``,

  /*
    fires toast, prompt, cancel-prompt, secondary-prompt, cancel-secondary-prompt zoom-to-active
  */
  is: 'add-section',

  properties: {
    activeItem: {
      type: String,
      notify: true
    },
    activeCommand: {
      type: String,
      notify: true
    },
    activeTool: {
      type: String,
      notify: true
    },
    activeButton: {
      type: String,
      notify: true
    },
    activeButtonModel: {
      type: Object
    },
    color: {
      type: String,
      value: '#00aaff'
    },
    icon: {
      type: String,
      value: 'arrow-drop-up'
    },
    jobid: {
      type: String
    },
    connections: {
      type: Object
    },
    designOnly: Boolean,
    latitude: Number,
    longitude: Number,
    modelConfig: Object,
    snapLine: {
      type: Object,
      notify: true
    },
    nodes: {
      type: Object
    },
    _secondaryPromptIsCancel: {
      type: Boolean
    },
    willRunCommand: {
      type: Boolean,
      notify: true
    }
  },

  init: function () {
    this.activeTool = 'addSection';
    this.activeCommand = 'add';
    this.fire('prompt', { text: 'Add Section' });
    this.fire('secondary-prompt', { text: 'Cancel' });
    this._secondaryPromptIsCancel = true;
    // this.fire('cancel-secondary-prompt');
  },

  add: function (closestItem, latitude, longitude) {
    var closestConnections = this.getClosestConnections(closestItem, latitude, longitude);
    this.closestConnections = {
      list: closestConnections.slice(0, 3),
      clickLatitude: latitude,
      clickLongitude: longitude,
      index: 0
    };
    this.activeItem = '';
    this._secondaryPromptIsCancel = false;
    this.action_secondary();
  },

  getClosestConnections: function (closestItem, latitude, longitude) {
    var closestConnections = [];
    var closestConnectionsList = [];
    if (closestItem != null && closestItem.item[0] == 'n') {
      var nodeId = closestItem.item.slice(1);
      var connections = SquashNulls(loadRenderMap.pointLocations[nodeId], 'data', 'n');
      for (var connId in connections) {
        let conn = SquashNulls(this.connections, connId);
        closestConnections.push({
          connId,
          distance: -1,
          n1: SquashNulls(this.nodes, conn.node_id_1),
          n2: SquashNulls(this.nodes, conn.node_id_2)
        });
        closestConnectionsList.push(connId);
        break;
      }
    }
    for (var connId in this.connections) {
      if (closestConnectionsList.indexOf(connId) == -1) {
        var n1 = SquashNulls(this.nodes, this.connections[connId].node_id_1);
        var n2 = SquashNulls(this.nodes, this.connections[connId].node_id_2);
        var distance = KatapultGeometry.CalcDistanceToLine(latitude, longitude, n1.latitude, n1.longitude, n2.latitude, n2.longitude);
        closestConnections.push({
          distance: distance,
          connId,
          n1: n1,
          n2: n2
        });
        closestConnectionsList.push(connId);
      }
    }
    closestConnections.sort(function (a, b) {
      return a.distance - b.distance;
    });
    return closestConnections;
  },

  // change active connection
  action_secondary: function () {
    if (this._secondaryPromptIsCancel) {
      this.cancel();
    } else {
      var closest = this.closestConnections.list[this.closestConnections.index];
      var snap = KatapultGeometry.SnapToLine(
        this.closestConnections.clickLatitude,
        this.closestConnections.clickLongitude,
        closest.n1.latitude,
        closest.n1.longitude,
        closest.n2.latitude,
        closest.n2.longitude
      );
      var update = {};
      if (this.closestConnections.sectionId == null) {
        this.closestConnections.sectionId = FirebaseWorker.ref(
          'photoheight/jobs/' + this.jobid + /connections/ + closest.connId + '/sections/'
        ).push().key;
      } else {
        var last = this.closestConnections.index - 1;
        if (last < 0) {
          last = this.closestConnections.list.length - 1;
        }
        // Remove the last placed section before inserting a new one
        update['connections/' + this.closestConnections.list[last].connId + '/sections/' + this.closestConnections.sectionId] = null;
        // Also remove the geofire data for the section
        const lastConnId = this.closestConnections.list[last].connId;
        update[`geohash/${lastConnId}:${this.closestConnections.sectionId}`] = null;
        const lastConnection = this.connections[lastConnId];
        GeofireTools.updateConnectionStyleForSectionChanges(
          lastConnId,
          lastConnection,
          { [this.closestConnections.sectionId]: null },
          update,
          this.jobStyles
        );
      }
      var section = {
        latitude: snap.lat,
        longitude: snap.long,
        multi_attributes: {}
      };
      var sectionAttributes = SquashNulls(this.modelConfig, 'section_attributes');
      for (var key in sectionAttributes) {
        section.multi_attributes[key] = { button_added: sectionAttributes[key] };
      }

      // Add any attributes from the button's model
      if (SquashNulls(this.activeButtonModel, 'section', 'attributes')) {
        for (let key in this.activeButtonModel.section.attributes) {
          if (this.activeButtonModel.section.attributes[key].value != null) {
            section.multi_attributes[key] = section.multi_attributes[key] || {};
            section.multi_attributes[key].button_added = this.activeButtonModel.section.attributes[key].value;
          }
        }
      }

      update['connections/' + closest.connId + '/sections/' + this.closestConnections.sectionId] = section;
      GeofireTools.setGeohash('sections', section, closest.connId, this.jobStyles, update, {
        sectionId: this.closestConnections.sectionId
      });
      const closestConnection = this.connections[closest.connId];
      GeofireTools.updateConnectionStyleForSectionChanges(
        closest.connId,
        closestConnection,
        { [this.closestConnections.sectionId]: section },
        update,
        this.jobStyles
      );
      FirebaseWorker.ref('photoheight/jobs/' + this.jobid).update(
        update,
        function (activeItem, closest, error) {
          if (error) {
            console.log(error);
            this.fire('toast', error);
          } else {
            this.activeCommand = 'commit';
            this.snapLine = {
              p1: {
                latitude: closest.n1.latitude,
                longitude: closest.n1.longitude
              },
              p2: {
                latitude: closest.n2.latitude,
                longitude: closest.n2.longitude
              }
            };
            this.activeItem = activeItem;
            this.fire('zoom-to-active');
            this.fire('prompt', { text: 'Commit' });
            this.fire('secondary-prompt', { text: 'Switch' });
            this._secondaryPromptIsCancel = false;
          }
        }.bind(this, 's' + closest.connId + ':' + this.closestConnections.sectionId, closest)
      );
      this.closestConnections.index++;
      if (this.closestConnections.index >= this.closestConnections.list.length) {
        this.closestConnections.index = 0;
      }
    }
  },

  commit: function () {
    // Create a promise so we can run the same code at the
    // end of the promise regardless of the outcome
    new Promise((resolve, reject) => {
      // Check if the insert section button's model says that the section should be edited
      if (this.activeItem && SquashNulls(this.activeButtonModel, 'section', 'open_for_editing')) {
        // Set the active tool and command so that we are in edit mode
        this.activeTool = 'editAttributes';
        this.activeCommand = 'edit';
        // Tell the map to run the command to edit the section
        this.fire('run-command', {
          items: [this.activeItem],
          callback: function (deleted) {
            // If we deleted the section while in edit
            // mode, then start the button over again
            if (deleted) {
              this.init();
              reject();
            } else {
              // Resolve the promise to run the normal commit code
              resolve();
            }
          }.bind(this),
          name: 'Section'
        });
      } else {
        // If we don't need to edit the section or can't find the active item,
        // then just resolve the promise to run the normal commit code
        resolve();
      }
    }).then(() => {
      this.snapLine = null;
      if (!this.designOnly) {
        this.willRunCommand = true;
        this.activeButton = null;
        this.activeTool = 'jobTimeCollection';
        this.activeCommand = 'change';
        this.fire('run-command');
      } else {
        this.init();
      }
    });
  },

  cancel: function () {
    this.snapLine = null;
    this.activeButton = null;
    this.activeTool = 'jobTimeCollection';
    this.activeCommand = 'change';
    this.fire('run-command');
    this._secondaryPromptIsCancel = false;
  },

  map_pan: function (latitude, longitude, closest) {
    if (this.activeCommand == 'commit') {
      var last = this.closestConnections.index - 1;
      if (last < 0) {
        last = this.closestConnections.list.length - 1;
      }
      var lastConn = this.closestConnections.list[last];
      var update = {};
      this.domHost.geo.updateLocation(
        'geohash/' + lastConn.connId + ':' + this.closestConnections.sectionId,
        [this.latitude, this.longitude],
        10,
        update
      );
      update['/connections/' + lastConn.connId + '/sections/' + this.closestConnections.sectionId + '/latitude'] = this.latitude;
      update['/connections/' + lastConn.connId + '/sections/' + this.closestConnections.sectionId + '/longitude'] = this.longitude;
      FirebaseWorker.ref('photoheight/jobs/' + this.jobid).update(
        update,
        function (error) {
          if (error) {
            console.log(error);
            this.fire('toast', error);
          }
          this.fire('update-active-item-location');
        }.bind(this)
      );
    } else if (this.activeCommand == 'add') {
      var closestConnections = this.getClosestConnections(closest, latitude, longitude);
      if (closestConnections.length > 0) {
        this.activeItem = 'c' + closestConnections[0].connId;
      } else {
        this.activeItem = '';
      }
    }
  },

  getByKey: function (type, id) {
    return this.domHost.$[type].child(id);
  }
});
